var _rect, _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgICalendar = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(30.895 -66.101)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-17.83,81.355H-27.96a2.191,2.191,0,0,1-2.189-2.189V69.036a2.192,2.192,0,0,1,2.189-2.189h10.13a2.191,2.191,0,0,1,2.189,2.189v10.13A2.19,2.19,0,0,1-17.83,81.355ZM-27.96,67.847a1.19,1.19,0,0,0-1.189,1.189v10.13a1.19,1.19,0,0,0,1.189,1.189h10.13a1.19,1.19,0,0,0,1.189-1.189V69.036a1.19,1.19,0,0,0-1.189-1.189Z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 13.508,
    height: 1,
    transform: "translate(-29.649 70.224)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.844,
    cy: 0.844,
    r: 0.844,
    transform: "translate(-23.739 73.257)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.844,
    cy: 0.844,
    r: 0.844,
    transform: "translate(-27.116 73.257)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.844,
    cy: 0.844,
    r: 0.844,
    transform: "translate(-20.362 73.257)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.844,
    cy: 0.844,
    r: 0.844,
    transform: "translate(-23.739 76.634)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.844,
    cy: 0.844,
    r: 0.844,
    transform: "translate(-27.116 76.634)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.844,
    cy: 0.844,
    r: 0.844,
    transform: "translate(-20.362 76.634)"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgICalendar, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/i_calendar.fbdea886.svg";
export { ForwardRef as ReactComponent };